<template>
  <Modal :title="course.id ? 'コース名編集' : 'コースの追加'" :loading="busy" @close="$emit('close')">
    <FormGrid>
      <dt>コース名<RequiredLabel /></dt>
      <dd>
        <TextInput placeholder="コース名" v-model.trim="name" maxlength="100" />
      </dd>
      <dt>金額</dt>
      <dd>
        <NumericInput class="price" v-model.number="price" :maxDigit="6" placeholder="金額" asInput />
      </dd>
      <dt>詳細</dt>
      <dd>
        <TextArea placeholder="詳細" v-model.trim="description" maxlength="200" />
      </dd>
    </FormGrid>
    <template #footer-center>
      <Button @click="$emit('close')">戻る</Button>
      <Button primary :disabled="!changed || !name" @click="save">{{ course.id ? '保存' : '追加' }}</Button>
    </template>
  </Modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Button from '@/components/atoms/Button'
import TextInput from '@/components/atoms/TextInput'
import TextArea from '@/components/atoms/TextArea'
import NumericInput from '@/components/molecules/NumericInput'
import Modal from '@/components/molecules/Modal'
import FormGrid from '@/components/molecules/FormGrid'
import RequiredLabel from '@/components/molecules/RequiredLabel'

export default {
  name: 'CourseEditModal',
  components: {
    Button,
    TextInput,
    TextArea,
    NumericInput,
    Modal,
    FormGrid,
    RequiredLabel,
  },
  computed: {
    ...mapState({
      course: state => state.courses.edit.courseDetail,
      busy: state => state.courses.edit.busy,
    }),
    ...mapGetters({
      changed: 'courses/edit/changedCourseDetail',
    }),
    name: {
      get() {
        return this.course.names?.jpn || ''
      },
      set(value) {
        this.$store.commit('courses/edit/updateCourseDetail', { names: { jpn: value } })
      },
    },
    price: {
      get() {
        return Math.ceil(this.course.price)
      },
      set(value) {
        this.$store.commit('courses/edit/updateCourseDetail', { price: value })
      },
    },
    description: {
      get() {
        return this.course.description
      },
      set(value) {
        this.$store.commit('courses/edit/updateCourseDetail', { description: value })
      },
    },
  },
  methods: {
    async save() {
      if (await this.$store.dispatch('courses/edit/saveCourseDetail')) {
        this.$emit('saved')
        this.$emit('close')
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.content {
  dl {
    grid-template-columns: 113px 1fr;
  }
}

>>> .required {
  margin-left: 8px;
}

.v-popover {
  width: auto;
}
</style>
